/* src/app/shared/components/notifications/notification-banner/notification-banner.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.notification-banner {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  font-size: 0.8125rem;
  padding: 1rem;
}
.notification-banner.info {
  background-color: rgba(0, 156, 189, 0.1);
  border-left: solid 5px #009cbd;
}
.notification-banner.success {
  background-color: rgba(100, 167, 11, 0.1);
  border-left: solid 5px #64a70b;
}
.notification-banner.warning {
  background-color: rgba(246, 139, 32, 0.1);
  border-left: solid 5px #f68b20;
}
.notification-banner.error {
  background-color: rgba(213, 0, 0, 0.1);
  border-left: solid 5px #d50000;
}
/*# sourceMappingURL=notification-banner.component.css.map */
